module.exports = __webpack_public_path__ + "static/media/playiconamb.a59208d9.svg";